import {memo} from 'react'
import {useTranslation} from 'react-i18next'
import {Selection} from '../../../../components/Selection'
import {TextInputV2} from '../../../../components/TextInputV2'
import {useSalesOrganization} from '../../../../hooks/useSalesOrganization'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {filterSelector, setFilterBankAccount} from '../../../../redux/slices/filterSlices'
import * as TableUI from '../../../../components/Table/Table'

export const RowFilter = memo(() => {
  const {t} = useTranslation()
  const {filterBankAccount: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()
  const {salesOrgOptions} = useSalesOrganization()
  const role = localStorage.getItem('role-flag')

  const handleChange = (value: Partial<typeof filter>) => {
    dispatch(setFilterBankAccount({...filter, ...value}))
  }

  return (
    <TableUI.TRowFilter>
      <td>
        <div>&nbsp;</div>
      </td>
      <td>
        { role == 'admin' && <Selection
            placeholder={t('TableBank.sales_org')}
            data={salesOrgOptions}
            value={filter?.sales_org_code ?? ''}
            onChange={(sales_org_code) => handleChange({sales_org_code})}
          />
         }
      </td>
      <td>
        <TextInputV2
          placeholder={t('mataUang')}
          value={filter?.currency ?? ''}
          onChange={({target}) => handleChange({currency: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('TableBank.bank_code')}
          value={filter?.bank ?? ''}
          onChange={({target}) => handleChange({bank: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('TableBank.bank_account')}
          value={filter?.bank_account ?? ''}
          onChange={({target}) => handleChange({bank_account: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('TableBank.bank_gl_account')}
          value={filter?.bank_gl_account ?? ''}
          onChange={({target}) => handleChange({bank_gl_account: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('TableBank.bank_clearing_acct')}
          value={filter?.bank_clearing_acct ?? ''}
          onChange={({target}) => handleChange({bank_clearing_acct: target.value})}
        />
      </td>
      <td>
        <Selection
          data={[
            {value: '1', label: 'Active'},
            {value: '0', label: 'Inactive'},
          ]}
          placeholder={t('TableBank.status')}
          value={filter?.status ?? ''}
          onChange={(status) => handleChange({status})}
        />
      </td>
      <td>
        <div>&nbsp;</div>
      </td>
    </TableUI.TRowFilter>
  )
})
